import { useContext } from "react"
import { ContentContext } from "../contexts/ContentContext"
import { MdOutlineErrorOutline } from "react-icons/md"
import { useTranslation } from "react-i18next"
import { formatTimestamp } from "../utils"



export const GenericErrorModal = () => {
    const { t } = useTranslation('errors')
    const { errorMessage, setErrorMessage } = useContext(ContentContext)


    const onClose = () => {
        setErrorMessage("")
    }

    return (
        <>
            <dialog id="generic-error-modal" className="modal">
                <div className="modal-box flex flex-col gap-3 items-center min-h-48 bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300">
                    <div className="flex  items-center text-red-600">
                        <h3 className="font-bold text-lg w-full text-center">{t('Error')}</h3>
                        <MdOutlineErrorOutline size={26} />
                    </div>
                    <div className="text-xl my-auto flex flex-col gap-2">

                        {
                            errorMessage.status && typeof errorMessage.message === "string" &&
                            <>
                                <span className="text-red-700">{t(errorMessage.status)}</span>
                                <span>{t(errorMessage.message)}</span>

                            </>
                        }
                        {
                            !errorMessage.status && typeof errorMessage.message === "string" &&
                            <span>{t(errorMessage.message)}</span>
                        }
                        {
                            errorMessage.status && typeof errorMessage.message !== "string" &&
                            <>
                                <span className="text-red-700">{t(errorMessage.status)}</span>
                                <span>{t(errorMessage.message[0].msg)}</span>
                            </>

                        }

                    </div>
                </div>
                <form method="dialog" className="modal-backdrop">
                    <button onClick={onClose}>close</button>
                </form>
            </dialog>
        </>
    )
}


export const BanErrorModal = () => {
    const { t } = useTranslation(['errors', 'edit'])
    const { banErrorMessage, setBanErrorMessage } = useContext(ContentContext)

    const onClose = () => {
        setBanErrorMessage(null)
    }

    return (
        <>
            <dialog id="ban-error-modal" className="modal">
                <div className="modal-box flex flex-col gap-3 items-center min-h-48 bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300">
                    <div className="flex  items-center text-red-600">
                        <h3 className="font-bold text-lg w-full text-center">{t('Error')}</h3>
                        <MdOutlineErrorOutline size={26} />
                    </div>
                    <div className="text-xl my-auto flex flex-col gap-2">
                        {
                            banErrorMessage &&
                            <>
                                <span className="text-red-600">{t(banErrorMessage.status)}</span>
                                <span>{t(banErrorMessage.message)}</span>
                                {
                                    banErrorMessage.until !== -1 &&
                                    <div className="flex items-center flex-wrap">
                                        <span className="min-w-36 max-w-36">{t('Ban Until', {ns: "edit"})}</span>
                                        <span className="text-red-600">{formatTimestamp(banErrorMessage.until * 1000)}</span>
                                    </div>
                                }
                            </>
                        }
                    </div>
                </div>
                <form method="dialog" className="modal-backdrop">
                    <button onClick={onClose}>close</button>
                </form>
            </dialog>
        </>
    )
}